<template>
  <div>
    <p>{{username}}</p>
    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'app',
  props: {
    username: String
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  data: function () {
    return {
      dropzoneOptions: {
        dictDefaultMessage: 'Fotos hier hereinziehen, oder die Fläche anklicken',
        url: '/static/upload/upload.php?userDir=' + this.username,
        thumbnailWidth: 150,
        maxFilesize: 10,
        timeout: 60000,
        headers: { 'My-Awesome-Header': 'header value' }
      }
    }
  },
  methods: {
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Upload/Upload.vue